import { ref, computed, watch } from '@vue/composition-api'
import { useModuleView } from './useModuleView'
import { capitalize } from '../../utils/filter'
import { getUserData } from '../../utils/utils'

import ModuleViewFormPrompt from '../../components/prompt/ModuleView3.vue'
import store from '../../store'
import router from '../../router'
import useAPI from '../../utils/useAPI'

export const mixinModuleViews = {
  components: {
    ModuleViewFormPrompt
  },
  props: {},
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isModuleViewModalShow = ref(false)
    const currentModuleView = ref({})
    const viewParametersRef = ref()

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const { submitValidatedModuleView, removeModuleView } = useModuleView()
    // const {} = useAPI()

    // const toggleParameterDetailsOpen = (viewType, module) => {
    //   currentModuleView.value = JSON.parse(JSON.stringify(store.getters['moduleView/getDefaultViewByModule'](viewType, module)))
    //   currentModuleView.value.listColumns = currentModuleView.value.listColumns.filter(lc => lc.key != 'actions')
    //
    //   // console.log(currentModuleView.value)
    //   isModuleViewModalShow.value = true
    // }

    const addModuleView = (viewType, module) => {
      currentModuleView.value = JSON.parse(JSON.stringify(store.getters['moduleView/getEmptyModuleView']))
      // currentModuleView.value.listColumns = currentModuleView.value.listColumns.filter(lc => lc.key != 'actions')
      currentModuleView.value.type = JSON.parse(JSON.stringify(viewType))
      currentModuleView.value.module = JSON.parse(JSON.stringify(module))

      isModuleViewModalShow.value = true
    }
    const deplicateModuleView = (moduleView) => {
      currentModuleView.value = JSON.parse(JSON.stringify(moduleView))
      currentModuleView.value.listColumns = currentModuleView.value.listColumns.filter(lc => lc.key != 'actions')
      currentModuleView.value.name = null
      delete currentModuleView.value.id

      isModuleViewModalShow.value = true
    }

    const editModuleView = (moduleView) => {
      currentModuleView.value = JSON.parse(JSON.stringify(moduleView))
      currentModuleView.value.listColumns = currentModuleView.value.listColumns.filter(lc => lc.key != 'actions')

      // console.log(currentModuleView.value)
      isModuleViewModalShow.value = true
    }

    const submitValidatedModuleViewLocal = () => {
      console.log(currentModuleView.value)
      submitValidatedModuleView(currentModuleView.value)
        .then((response) => {
          isModuleViewModalShow.value = false
          // resetSupplierInvoice()
          viewParametersRef.value.update()
        })
    }

    const setDefaultModuleView = ({ moduleView }) => {
      console.log(getUserData().id)
      store.dispatch('user2/getUser', getUserData().id)
        .then(response => {
          response.data['defaultView' + capitalize(moduleView.module)] = moduleView

          store.dispatch('user2/updateUser', response.data)
            .then(response => {
              let userData = getUserData()
              userData.defaultViews[moduleView.module].id = moduleView.id
              userData.defaultViews[moduleView.module].type = moduleView.type
              localStorage.setItem('userData', JSON.stringify(userData))

              viewParametersRef.value.update()
            })

        })
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isModuleViewModalShow,
      currentModuleView,
      viewParametersRef,

      // Computed

      // Methods
      // toggleParameterDetailsOpen,
      addModuleView,
      deplicateModuleView,
      editModuleView,
      removeModuleView,
      submitValidatedModuleViewLocal,
      setDefaultModuleView,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    deleteModuleViewAlert (moduleView) {
      this.$bvModal
        .msgBoxConfirm(this.$t('DeleteAlert', { msg: this.$t('theModuleView') }), {
          okVariant: 'danger',
          okTitle: this.capitalize(this.$t('delete')),
          cancelVariant: 'outline-secondary',
          cancelTitle: this.capitalize(this.$t('cancel')),
          centered: true,
        })
        .then(value => {
          if (value == true) {
            this.removeModuleView(moduleView)
          }
        })
    }
  },
  mounted () {
  },
  created () {
  }
}